import "core-js/modules/es7.object.values";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
export default {
  name: 'Characteristics',
  props: {
    dangerousProduct: {
      type: String,
      default: ''
    },
    dangerousProductTranslated: {
      type: String,
      default: ''
    },
    infoCompDescription: {
      type: String,
      default: ''
    },
    infoCompLabel: {
      type: String,
      default: ''
    },
    specificityLogo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    detailsSize: {
      type: Number,
      default: 0
    },
    commonDetails: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    isInfoComp: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      isPlaying: false,
      imagesPath: 'https://cdn.maisonsdumonde.com/images/segmentations/'
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    hasVideos: function hasVideos() {
      return this.videos !== null && this.videos.length;
    },
    detailsCommon: function detailsCommon() {
      return Object.entries(this.commonDetails).reduce(function (details, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (key === 'document') {
          return details;
        }

        return _objectSpread({}, details, _defineProperty({}, key, value));
      }, {});
    }
  }),
  methods: {
    labels: function labels(_labels) {
      return Object.values(_labels).filter(function (label) {
        return label.description;
      });
    }
  }
};